// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"Cyck2"};